// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { Amulet } from '@daml.js/splice-amulet/lib/Splice/Amulet';
import { useLedgerApiClient } from '../../../contexts/LedgerApiContext';
import { useModuleParty } from '../../../contexts/ModuleContext';
import TemplateContract from '../../../utils/TemplateContract';
import { useLedgerEnd } from '../ledger/useLedgerEnd';

const useCoins: () => UseQueryResult<TemplateContract<Amulet>[], string> = () => {
  const ledgerApi = useLedgerApiClient();
  const party = useModuleParty();
  const offset = useLedgerEnd();

  return useQuery({
    keepPreviousData: true, // to avoid 0 CC flickering in the header
    queryKey: ['queryCoins', offset, ledgerApi, party],
    queryFn: async () => {
      return ledgerApi.queryCoins(offset!, party);
    },
    refetchInterval: false,
    enabled: !!offset,
  });
};

export default useCoins;
